export default __webpack_public_path__ + "static/media/6.c1d5b81c.png";